import { Component, ElementRef, output, viewChild } from '@angular/core';

@Component({
  selector: 'ez-info-button',
  templateUrl: './info-button.component.html',
  styleUrl: './info-button.component.scss',
})
export class InfoButtonComponent {
  readonly icon = viewChild.required<ElementRef<HTMLElement>>('icon');
  readonly clickEvent = output();

  onClick() {
    this.clickEvent.emit();
  }
}
